"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertFunction = assertFunction;
exports.assertParameters = assertParameters;
exports.assertReturn = assertReturn;
exports.assertEqualsFunction = assertEqualsFunction;
exports.assertEqualsParameters = assertEqualsParameters;
exports.assertEqualsReturn = assertEqualsReturn;
exports.isFunction = isFunction;
exports.isParameters = isParameters;
exports.isReturn = isReturn;
exports.equalsFunction = equalsFunction;
exports.equalsParameters = equalsParameters;
exports.equalsReturn = equalsReturn;
exports.validateFunction = validateFunction;
exports.validateParameters = validateParameters;
exports.validateReturn = validateReturn;
exports.validateEqualsFunction = validateEqualsFunction;
exports.validateEqualsParameters = validateEqualsParameters;
exports.validateEqualsReturn = validateEqualsReturn;
const NoTransformConfigurationError_1 = require("./transformers/NoTransformConfigurationError");
/** @internal */
function assertFunction() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.assertFunction");
}
/** @internal */
function assertParameters() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.assertParameters");
}
/** @internal */
function assertReturn() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.assertReturn");
}
/** @internal */
function assertEqualsFunction() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.assertEqualsFunction");
}
/** @internal */
function assertEqualsParameters() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.assertEqualsParameters");
}
/** @internal */
function assertEqualsReturn() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.assertEqualsReturn");
}
/** @internal */
function isFunction() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.isFunction");
}
/** @internal */
function isParameters() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.isParameters");
}
/** @internal */
function isReturn() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.isReturn");
}
/** @internal */
function equalsFunction() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.equalsFunction");
}
/** @internal */
function equalsParameters() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.equalsParameters");
}
/** @internal */
function equalsReturn() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.equalsReturn");
}
/** @internal */
function validateFunction() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.validateFunction");
}
/** @internal */
function validateParameters() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.validateParameters");
}
/** @internal */
function validateReturn() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.validateReturn");
}
/** @internal */
function validateEqualsFunction() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.validateEqualsFunction");
}
/** @internal */
function validateEqualsParameters() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.validateEqualsParameters");
}
/** @internal */
function validateEqualsReturn() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("functional.validateEqualsReturn");
}
//# sourceMappingURL=functional.js.map